import { render, staticRenderFns } from "./ExhibitionsHome.vue?vue&type=template&id=5e8e2599&"
import script from "./ExhibitionsHome.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports